if (!customElements.get('tpt-price-range')) {
	customElements.define(
		'tpt-price-range',
		class TptPriceRange extends HTMLElement {
			constructor() {
				super();

				const minInputElement = document.querySelector('[data-price-range="GTE"]');
				const maxInputElement = document.querySelector('[data-price-range="LTE"]');
				const inputSlider = this.querySelector('input');
				const minValue = parseFloat(inputSlider.getAttribute('data-min'));
				const maxValue = parseFloat(inputSlider.getAttribute('data-max'));
				const minCurrentvalue = parseFloat(inputSlider.getAttribute('data-min-current'));
				const maxCurrentvalue = parseFloat(inputSlider.getAttribute('data-max-current'));

				var priceSlide = new Slider(inputSlider, {
					min: minValue,
					max: maxValue,
					value: [minCurrentvalue, maxCurrentvalue],
					range: true,
				});

				priceSlide.on('change', function (ev) {
					var newMinValue = priceSlide.getValue()[0];
					var newMaxValue = priceSlide.getValue()[1];

					minInputElement.value = newMinValue;
					maxInputElement.value = newMaxValue;
				});

				priceSlide.on('slideStop', function (ev) {
					minInputElement.dispatchEvent(new Event('input', { bubbles: true }));
				});
			}
		}
	);
}
